import { useUserTime } from '../../../../hooks/useUserTime';
import { ArgFieldValue } from './ArgField';

function isRenderableDate(scheduledAt: string) {
  return !!scheduledAt && !Number.isNaN(new Date(scheduledAt).getTime());
}

export function ScheduledAtArgValue({ scheduledAt }: { scheduledAt: string }) {
  const formatUserTime = useUserTime();

  if (!isRenderableDate(scheduledAt)) {
    return <ArgFieldValue>{scheduledAt}</ArgFieldValue>;
  }

  return <ArgFieldValue>{formatUserTime(scheduledAt)}</ArgFieldValue>;
}
